import { delay } from 'src/app/utils/delay';
import { log } from 'src/app/utils/logging';

const events: Record<string, boolean> = {};

export const setPageViewEvent = (jobId: string) => {
  if (!jobId) {
    log.error(
      'Analytics | CheckPageViewEvent | JobId is missing from page event',
    );
  }

  events[jobId] = true;
};

export const checkPageViewEvent = async (jobId: string) => {
  if (events[jobId]) {
    return;
  }

  await delay(1000);

  if (events[jobId]) {
    return;
  }

  log.error(
    'Analytics | CheckPageViewEvent | Page event not sent or delay',
    {
      jobId,
    },
    true,
  );
};
